
var GoalsList = function(options){
    var oThis = this;

    oThis.defaults = {
        portfolioid: null,
        canEdit: false
    }

    oThis.settings = $.extend( {}, oThis.defaults, options );
    oThis.Actions = Reflux.createActions(['fetchGoals']);
    oThis.containerID;
    oThis.msgStack = new MessageStack();
    oThis.createStore();

    oThis.handleStack = function(){
        oThis.msgStack.Display(); //should we put these in a program builder container?
        oThis.msgStack.Clear();
    }

    //Program Designer
    oThis.GoalsList = createReactClass({
        mixins: [Reflux.connect(oThis.GoalsStore, 'goals')],

        componentDidUpdate: function(){
            var $component = $(ReactDOM.findDOMNode(this));
            reactFixRowsCols($component);
            $('.collapsible',$component).collapsible();
        },

        componentDidMount: function(){
            var $component = $(ReactDOM.findDOMNode(this));
        },

        render: function() {
            var oComponent = this;
            var emptyMsg = "You haven't created any goals yet.";

            if(this.state.goals){
                var goals = [];
                for(var i = 0; i < this.state.goals.items.length; i++){
                    var oItem = this.state.goals.items[i];
                    goals.push(<oThis.GoalsListItem item={oItem} key={oItem.id} />);
                }

                if(goals.length > 0){
                    hideOnboarding();
                    return (
                        <div className="portfolio-content-goals">
                            <ul className="collection collapsible goals-list" data-collapsible="expandable">
                                {goals}
                            </ul>
                        </div>
                    );
                } else {
                    showOnboarding();
                    return (
                        <div className="portfolio-content-goals">
                            {/* <div className="alert alert--information text--xl">{emptyMsg}</div> */}
                        </div>
                    );
                }

            } else {
                return (
                    <div className="portfolio-content-goals">
                        <div className="spinner spinner--pulsing"><div className="spinner-ring"></div></div>
                    </div>
                );
            }

        }
    });


    oThis.GoalsListItem = createReactClass({
        componentDidMount: function() {
            var $component = $(ReactDOM.findDOMNode(this));
            var oComponent = this;
            $('[data-popover="tooltip"]',$component).tooltip();
        },

        componentDidUpdate: function() {
            this.handleUpdateExpand();
        },

        handleExpand: function(e) {
            var oComponent = this;
            e.stopPropagation();
            var $component = $(ReactDOM.findDOMNode(this));
            var $item = $(e.target).closest("li");
            var $target = $item.find('.collapsible-body');
            var bEmpty = $target.is(":empty()");

            if(bEmpty){

                httpGet(this.props.item.view_url).then(
                    function(value) {
                        $target.html(value);
                    })
                .catch(
                    function(reason) {
                        console.error('Error loading goal.', this.props, reason);
                        alertify.error('Unable to load goal.')
                    });
            }

        },

        handleUpdateExpand: function() {
            var oComponent = this;
            var $component = $(ReactDOM.findDOMNode(this));
            var $target = $component.find('.collapsible-body');
            var bEmpty = $target.is(":empty()");

            if(!bEmpty){
                httpGet(this.props.item.view_url).then(
                    function(value) {
                        $target.html(value);
                    })
                .catch(
                    function(reason) {
                        console.error('Error reloading goal.', this.props, reason);
                        alertify.error('Unable to reload goal.')
                    });
            }
        },

        render: function() {
            var oComponent = this;
            var skillsCount = this.props.item.skills.length;
            var improvedCount = 0;
            this.props.item.skills.forEach(function(element,index){
                improvedCount += (element.num_items > 0) ? 1 : 0;
            });

            return (
                <li className="collection-item">
                        <button className="collapsible-header clearfix" onClick={this.handleExpand}>
                            <label className="goals-list-title">{this.props.item.title}</label>
                            <div className="progress progress--small" data-popover="tooltip" data-placement="top" data-original-title="Progress Towards Improving All Goal Skills">
                                <span style={{width: this.props.item.score + "%"}} className="bg--success"></span>
                            </div>
                            <div className="goals-list-stats">
                                {/* Skills <span className="flag flag--badged flag--primary flag--outlined" data-popover="tooltip" data-placement="top" data-original-title="Skills Improved Since Start">{improvedCount + "/" + skillsCount}</span> */}
                                Skills <span className="flag flag--badged flag--primary flag--outlined" data-popover="tooltip" data-placement="top" data-original-title="Unique Skills in Goal Set">{skillsCount}</span>
                                <span className="emspace"> </span>
                                Improved <span className="flag flag--badged flag--primary flag--outlined" data-popover="tooltip" data-placement="top" data-original-title="Skills Improved Since Start">{improvedCount}</span>
                                <span className="emspace"> </span>
                                <i className="icon-comment-o"></i> <span className="goals-list-count" data-popover="tooltip" data-placement="top" data-original-title="Comments Made">{this.props.item.comment_count}</span>
                            </div>
                        </button>

                        <div className="collapsible-body collapsible-body--featured"></div>
                </li>
            );

        }
    });

};

GoalsList.prototype.renderCollection = function(containerID) {
    this.containerID = containerID;
    ReactDOM.render(<this.GoalsList />, document.getElementById(this.containerID));
}

//REFLUX STORE
GoalsList.prototype.createStore = function() {
    var oThis = this;

    oThis.GoalsStore = Reflux.createStore({
        listenables: oThis.Actions,
        goals: {}, //goals store

        init: function() {
        },

        getInitialState: function() {
            this.onFetchGoals();
        },

        onFetchGoals: function() {
            //console.log('fetching goals...')
            var oStore = this;
            var endpoint = buildRoute(mantlroutes.portfolio_goal_list,{ portfolioid: oThis.settings.portfolioid });

            httpGet(endpoint).then(
                function(value) {
                    oStore.goals.items = JSON.parse(value);
                    oStore.trigger(oStore.goals);
                })
            .catch(
                function(reason) {
                    console.error('Error loading goals.', reason);
                    alertify.error('Unable to load goals.')
                });
        }

    });
}
